export default function TrustedOrganizations({
  title,
  organizations,
}: {
  title: string;
  organizations: string[];
}) {
  return (
    <div className="flex flex-col gap-4 text-center">
      <h1 className="text-lightBlack mb-5 text-[20px] font-normal">{title}</h1>
      <div className="grid items-center justify-center gap-20 md:flex">
        {organizations.map((organization) => (
          <img src={organization} alt={organization} />
        ))}
      </div>
    </div>
  );
}
